import { Area, InputFactoryProp } from "../../../../shared/interfaces";

export const getInputsFilter = (areaCombo: Area[]): InputFactoryProp[] => {
  return [
    {
      element: "select",
      isMulti: true,
      placeHolder: "Área",
      items: areaCombo,
      name: "area",
    },
    {
      element: 'input',
      placeHolder: 'Apellido y/o Nombre',
      allowClear: true,
      name: 'keyword',
      isMulti: false,
    },
  ];
};